// extracted by mini-css-extract-plugin
export default {"wrapper":"ProvidersItemFooterWrapper_wrapper__hdI1Q","label":"ProvidersItemFooterWrapper_label__NXkpR"};